import styled from 'styled-components';
import { Button } from '../Button/styles';
import { Input } from '../Form/styles';
import { Format, StyleColor, navBarHeight } from '../../utils/styles-constants';

export const StyledAuthentication = styled('div') `
`;

export const ExcelAuthenticationContainer = styled('div')`
`;

export enum SamlIframeOrigin {
	App = 'app',
	Authentication = 'authentication'
}

interface SamlAuthenticationIframeProps {
	origin: SamlIframeOrigin;
}

export const SamlAuthenticationIframe = styled('iframe')`
	position: absolute;
	border: none;
	top: 0;
	left: 0;
	${(props: SamlAuthenticationIframeProps) => {
		switch (props.origin) {
			case SamlIframeOrigin.App:
				return (
					`width: 10%;
					height: 10%;
					display: none;`
				);
			case SamlIframeOrigin.Authentication:
				return (
					`width: 100%;
					height: 100%;
					vertical-align: top;
					bottom: 0;
					right: 0;`
				);
		}
	}}
`;

export const AuthenticationHeader = styled('div') `
	background-color: ${StyleColor.White};
	position: absolute;
	right: 0;
	left: 0;
	z-index: 5;
	display: flex;
	box-sizing: border-box;
	padding: 0 15px;
	width: 100%;
	height: ${navBarHeight};
	border: 0;
	border-bottom: 1px solid ${StyleColor.Grey200};
	justify-content: center;
	align-items: center;

	> * {
		flex-grow: 1;
		flex-basis: 33%;
	}

	@media ${Format.Smartphone}, ${Format.Tablet} {
		padding: 0 5px;
	}
`;

export const AuthenticationContent = styled('div') `
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

export const blockButtonsStyle = `
	width: 100%;
	max-width: 300px;
	box-sizing: border-box;
`;

export const AuthenticationForm = styled('form') `
	${blockButtonsStyle}
`;

interface AuthenticateButtonProps {
	disabled?: boolean;
}

const authenticateEnabledColor = StyleColor.Blue800;
const authenticateDisabledColor = StyleColor.Grey400;

export const AuthenticationButtonWrapper = styled('div')`
	display: flex;
	justify-content: center;
	margin-top: 30px;
`;

export const AuthenticateButton = styled(Button)`
	display: inline-block;
	border-color: ${(props: AuthenticateButtonProps) => !props.disabled ? authenticateEnabledColor : authenticateDisabledColor};
	background-color: ${(props: AuthenticateButtonProps) => !props.disabled ? authenticateEnabledColor : authenticateDisabledColor };
	color: ${StyleColor.White};
	max-height: 33px;
	margin: 0 auto;
	border-radius: 24px;
	width: auto;
	padding: 0 30px;
	font-size: 14px;
	letter-spacing: 0.5px;
	font-weight: 400;

	@media (hover: hover) {
		&:hover {
			border-color: ${(props: AuthenticateButtonProps) => !props.disabled ? authenticateEnabledColor : authenticateDisabledColor};
			background-color: ${(props: AuthenticateButtonProps) => !props.disabled ? authenticateEnabledColor : authenticateDisabledColor };
			color: ${StyleColor.White};
		}
	}
`;

export const AuthenticationInputWrapper = styled('div')`
	height: 60px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-end;
	padding-top: 5px;
	position: relative;
`;

export const AuthenticateFormInput = styled(Input)`
	height: 43px;
	&[name=password] {
		padding-right: 40px;
	}
	&::-ms-reveal {
		display: none;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Authentication/styles.ts